import { useFilterOperators } from "../use-filter-operators";
import { useTransformSortParams } from "../use-transform-sort-params";
import { useMutation } from "react-query";
import eventEmitter from "../../events";
import { EVENT_AJAXING } from "../../data";

export const useSearch = (sourcePage, includeTrackingNumbers = false, searchApi, filterModel = {}) => {
    const transformFilters = useFilterOperators(filterModel);
    const transformSortParams = useTransformSortParams();

    return useMutation(({ searchParams, pagingParams, isUsingExternalFilters }) => {
        const params = pagingParams.reduce((param, { id, value }) => {
            if (id === "pageNumber") {
                value += 1;
            }

            return {
                ...param,
                [id]: value,
            };
        }, []);

        eventEmitter.emit(EVENT_AJAXING);

        return searchApi(
            {
                PagingInfo: {
                    PageSize: parseInt(params["pageSize"], 10),
                    PageNumber: parseInt(params["pageNumber"], 10),
                },
                Filters: transformFilters(searchParams, isUsingExternalFilters),
                sortColumns: transformSortParams(params.originalSort || []),
            },
            sourcePage,
            includeTrackingNumbers
        );
    });
};
